const PREVIEW_FIELDS = [
  "previewImageUrl", "previewUrl", "previewStatus", "previewGeneratedAt",
  "previewError", "renderPreviewId", "previewSourceType", "previewKind", "sourceContentType",
];

const idOf = (value = {}) => String(value?.id ?? value?.artworkId ?? value?.ArtWorkId ?? "").trim();
const decorationIdOf = (value = {}) => String(value?.DecorationId ?? value?.decorationId ?? "").trim();
const sourceOf = (value = {}) => String(
  value?.Image ?? value?.FileUrl ?? value?.filePath ?? value?.proofFilePath ?? ""
).trim();

const findPreview = (artwork, previews) => {
  const artworkId = idOf(artwork);
  const decorationId = decorationIdOf(artwork);
  const source = sourceOf(artwork);
  return previews.find((preview) =>
    (artworkId && idOf(preview) === artworkId) ||
    (decorationId && decorationIdOf(preview) === decorationId) ||
    (source && sourceOf(preview) === source)
  );
};

const mergeArtwork = (artwork, previews) => {
  if (!artwork || typeof artwork !== "object") return artwork;
  const preview = findPreview(artwork, previews);
  if (!preview) return artwork;
  const next = { ...artwork };
  PREVIEW_FIELDS.forEach((field) => {
    if (preview[field] !== undefined) next[field] = preview[field];
  });
  return next;
};

export const mergeGeneratedArtworkPreviews = (salesOrder = {}, previews = []) => ({
  ...salesOrder,
  products: (salesOrder?.products || []).map((product) => {
    const mergeDecorations = (decorations = []) => decorations.map((decoration) => ({
      ...decoration,
      ArtWork: mergeArtwork(decoration?.ArtWork || decoration?.artwork, previews),
    }));
    const next = { ...product };
    if (Array.isArray(product?.ArtWorks)) {
      next.ArtWorks = product.ArtWorks.map((artwork) => mergeArtwork(artwork, previews));
    }
    if (Array.isArray(product?.artworks)) {
      next.artworks = product.artworks.map((artwork) => mergeArtwork(artwork, previews));
    }
    if (Array.isArray(product?.decorations)) {
      next.decorations = mergeDecorations(product.decorations);
    }
    if (Array.isArray(product?.Decorations)) {
      next.Decorations = mergeDecorations(product.Decorations);
    }
    return next;
  }),
});
